export * from './spt-firestore.fns';
export * from './spt-firestore.model';
export * from './spt-firestore.service';
